import Investments from "./investments";

export default Investments;
